import { render, staticRenderFns } from "./CompanyTitle.vue?vue&type=template&id=537dc303&"
import script from "./CompanyTitle.vue?vue&type=script&lang=js&"
export * from "./CompanyTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports